module.exports = __webpack_public_path__ + "static/media/20210109_210444_719_IMG_1696.bd1382e0.jpg";